module.exports = __webpack_public_path__ + "static/media/featureimage.4470a1d8.jpg";